(function () {
  'use strict';

  function formatWithPattern(cents, pattern) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, pattern);
    }

    var value = (Number(cents || 0) / 100).toFixed(2);
    var token = (pattern || '€{{amount}}').match(/\{\{\s*(\w+)\s*\}\}/);
    if (!token) return '€' + value;
    return pattern.replace(token[0], value);
  }

  function numeric(value) {
    var result = Number(value || 0);
    return Number.isFinite(result) ? result : 0;
  }

  function comparePrice(variant) {
    return numeric(variant && (variant.compare_at_price != null ? variant.compare_at_price : variant.compareAtPrice));
  }

  function currentPrice(variant) {
    return numeric(variant && variant.price);
  }

  function isHiddenOption(name) {
    return /(size|taille|größe|grösse|taglia|talla|maat|størrelse)/i.test(name || '');
  }

  function isEmptyValue(value) {
    return !value || value === 'Default Title';
  }

  function displaySpecValue(name, value, summary) {
    var result = String(value || '');
    if (/(carat|karat|quilate|karaat)/i.test(name || '')) {
      result = result
        .replace(/^(\d+)\.0\s*(?:ct|carat)$/i, '$1 ct')
        .replace(/^(\d+(?:[.,]\d+)?)\s*(?:ct|carat)$/i, '$1 ct');
    }
    if (/(gemstone|stone|edelstein|pierre|gema|pietra|edelsteen|edelsten)/i.test(name || '')) {
      var stoneValue = result.toLowerCase();
      if (stoneValue.indexOf('moissanite') !== -1 || stoneValue.indexOf('moissanit') !== -1) {
        return summary.dataset.stoneMoissanite || result;
      }
      if (stoneValue.indexOf('diamond') !== -1 || stoneValue.indexOf('diamant') !== -1) {
        return summary.dataset.stoneDiamond || result;
      }
      return summary.dataset.stoneGemstone || result;
    }
    return result;
  }

  function init(summary) {
    var productSource = summary.querySelector('[data-amour-offer-product-json]');
    if (!productSource) return;

    var product;
    try {
      product = JSON.parse(productSource.textContent);
    } catch (error) {
      return;
    }

    var variants = product.variants || [];
    // The Ovale configurator wraps a generic product section. Select the
    // configurator root explicitly so its custom variant event reaches this
    // listener even while ring size is still unselected.
    var root = summary.closest('[data-ovale-pdp]') ||
      summary.closest('[data-df-product]') ||
      summary.closest('[data-section-type="product"]') ||
      document;
    var moneyFormat = summary.dataset.moneyFormat || window.money_format || '€{{amount}}';

    function findVariant(id) {
      var numericId = String(id || '');
      return variants.find(function (variant) { return String(variant.id) === numericId; });
    }

    function inclusionFor(variant) {
      if (summary.dataset.isRing !== 'true') return null;
      var context = ((variant && variant.options) || []).join(' ').toLowerCase();
      if (context.indexOf('moissanite') !== -1) return summary.dataset.inclusionMoissanite;
      if (context.indexOf('diamond') !== -1 || context.indexOf('diamant') !== -1) return summary.dataset.inclusionDiamond;
      if (summary.dataset.stoneType === 'moissanite') return summary.dataset.inclusionMoissanite;
      if (summary.dataset.stoneType === 'diamond') return summary.dataset.inclusionDiamond;
      return summary.dataset.inclusionGemstone;
    }

    function update(variant) {
      if (!variant) return;

      var price = currentPrice(variant);
      var compare = comparePrice(variant);
      var saving = Math.max(0, compare - price);
      var discounted = compare > price && price >= 0;
      var percentage = discounted ? Math.round((saving * 100) / compare) : 0;
      var priceNode = summary.querySelector('[data-amour-offer-price]');
      var compareNode = summary.querySelector('[data-amour-offer-compare]');
      var dealNode = summary.querySelector('[data-amour-offer-deal]');
      var pillNode = summary.querySelector('[data-amour-offer-pill]');
      var savingNode = summary.querySelector('[data-amour-offer-saving]');
      var inclusionNode = summary.querySelector('[data-amour-offer-inclusion]');
      var certificateNode = summary.querySelector('[data-amour-offer-certificate]');
      var accessoryIds = summary.dataset.bfAccessoryVariantIds || '';
      var isAccessoryBlackFriday = accessoryIds.indexOf('|' + String(variant.id) + '|') !== -1;
      var isBlackFriday = summary.dataset.bfRing === 'true' || isAccessoryBlackFriday;
      if (accessoryIds) summary.classList.toggle('amour-offer--bf', isBlackFriday);
      var campaignNode = summary.querySelector('[data-amour-offer-bf-campaign]');
      var klarnaNode = summary.querySelector('[data-amour-offer-bf-klarna]');
      var standardPillNode = summary.querySelector('[data-amour-offer-standard-pill]');
      if (campaignNode) campaignNode.hidden = !isBlackFriday;
      if (klarnaNode) klarnaNode.hidden = !isBlackFriday;
      if (standardPillNode) {
        standardPillNode.textContent = percentage + (summary.dataset.labelOffSuffix || '% off');
        standardPillNode.hidden = isBlackFriday || !discounted;
      }

      if (priceNode) priceNode.innerHTML = formatWithPattern(price, moneyFormat);
      if (compareNode) {
        compareNode.innerHTML = discounted ? formatWithPattern(compare, moneyFormat) : '';
        compareNode.hidden = !discounted;
      }
      if (dealNode) dealNode.hidden = !discounted;
      if (pillNode) {
        if (summary.dataset.bfRing === 'true' || accessoryIds) {
          var percentNode = pillNode.querySelector('[data-amour-offer-percent]');
          if (percentNode) percentNode.textContent = percentage + '%';
          pillNode.setAttribute('aria-label', percentage + (summary.dataset.labelOffSuffix || '% off'));
          pillNode.hidden = !discounted;
        } else {
          pillNode.textContent = percentage + (summary.dataset.labelOffSuffix || '% off');
        }
      }
      if (savingNode) savingNode.innerHTML = (isBlackFriday ? (summary.dataset.labelTodaySave || 'Today you save') : (summary.dataset.labelSave || 'Save')) + ' <span class="money">' + formatWithPattern(saving, moneyFormat) + '</span>';

      var inclusion = inclusionFor(variant);
      if (inclusionNode && (inclusion || summary.dataset.inclusionStandard)) inclusionNode.textContent = isBlackFriday ? (summary.dataset.labelBfTotal || 'Total Price: everything included') : (inclusion || summary.dataset.inclusionStandard);
      if (certificateNode) {
        var optionContext = (variant.options || []).join(' ').toLowerCase();
        certificateNode.hidden = accessoryIds ? !isAccessoryBlackFriday : (optionContext.indexOf('moissanite') !== -1 || summary.dataset.stoneType !== 'diamond');
      }

      var options = variant.options || [];
      summary.querySelectorAll('[data-amour-offer-spec-index]').forEach(function (item) {
        var index = Number(item.dataset.amourOfferSpecIndex);
        var value = item.querySelector('[data-amour-offer-spec-value]');
        var optionName = item.dataset.amourOfferSpecName || '';
        var optionValue = options[index] || '';
        item.hidden = isHiddenOption(optionName) || isEmptyValue(optionValue);
        if (value) value.textContent = displaySpecValue(optionName, optionValue, summary);
      });
    }

    function updateFromForm() {
      var idInput = root.querySelector('[name="id"]');
      var matched = idInput && findVariant(idInput.value);
      if (matched) update(matched);
    }

    summary.__amourOfferUpdate = update;
    root.addEventListener('ovale:variant:change', function (event) {
      var candidate = event.detail && (event.detail.variant || event.detail.displayVariant);
      var matched = candidate && findVariant(candidate.id);
      if (matched) update(matched);
    });
    document.addEventListener('variant:change', function (event) {
      var candidate = event.detail && event.detail.variant;
      var matched = candidate && findVariant(candidate.id);
      if (matched) update(matched);
    });
    document.addEventListener('amour:variant:change', function (event) {
      var form = event.detail && event.detail.form;
      if (form && root !== document && !root.contains(form)) return;
      var candidate = event.detail && event.detail.variant;
      var matched = candidate && findVariant(candidate.id);
      if (matched) update(matched);
    });
    root.addEventListener('change', function () {
      window.setTimeout(updateFromForm, 0);
    });
  }

  function start() {
    document.querySelectorAll('[data-amour-offer][data-amour-offer-mode="pdp"]').forEach(init);

    var certificationId = 'amour-product-certification';

    function stickyHeaderOffset() {
      var header = document.querySelector('.wrapper-header.wrapper_header_default') ||
        document.querySelector('[data-amour-site-header]');
      if (!header) return 16;

      var rect = header.getBoundingClientRect();
      var style = window.getComputedStyle(header);
      var overlapsViewport = rect.height > 0 && rect.bottom > 0 && rect.top < 1;
      var isPinned = style.position === 'sticky' || style.position === 'fixed';
      return overlapsViewport && isPinned ? Math.ceil(rect.bottom) + 16 : 16;
    }

    function openAndRevealCertification(behavior, moveFocus) {
      var target = document.getElementById(certificationId);
      if (!target) return;

      if (target.tagName.toLowerCase() === 'details') target.open = true;

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          var top = window.scrollY + target.getBoundingClientRect().top - stickyHeaderOffset();
          window.scrollTo({ top: Math.max(0, top), behavior: behavior || 'auto' });

          if (moveFocus) {
            var summary = target.querySelector('summary');
            if (summary) summary.focus({ preventScroll: true });
          }
        });
      });
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href="#' + certificationId + '"]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      event.preventDefault();
      if (window.location.hash !== '#' + certificationId) {
        window.history.pushState(null, '', '#' + certificationId);
      }
      openAndRevealCertification('smooth', true);
    });

    window.addEventListener('hashchange', function () {
      if (window.location.hash === '#' + certificationId) {
        window.setTimeout(function () {
          openAndRevealCertification('smooth', false);
        }, 0);
      }
    });

    if (window.location.hash === '#' + certificationId) {
      openAndRevealCertification('auto', false);
      window.addEventListener('load', function () {
        window.setTimeout(function () {
          openAndRevealCertification('auto', false);
        }, 100);
      }, { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
